export type LikertScaleValue = 1 | 2 | 3 | 4 | 5;
export type WeekdayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface WeeklyCheckinAnswers {
    sleepQuality: LikertScaleValue;
    lifeStress: LikertScaleValue;
    bodyStatus: LikertScaleValue;
    hasSharpPain: boolean;
}

export interface WeeklyCheckinSubmission {
    answers: WeeklyCheckinAnswers;
    submittedAt: string;
    adaptation: WeeklyCheckinAdaptationAction;
}

export interface WeeklyCheckinPreferences {
    enabled: boolean;
    dayOfWeek: WeekdayIndex;
    time: string; // HH:mm 24h
    pushEnabled: boolean;
}

export interface WeeklyCheckinPreferencesRow {
    enabled: boolean;
    day_of_week: number;
    time: string;
    push_enabled: boolean;
}

export type WeeklyCheckinActionType =
    | 'FORCE_REST_WEEK'
    | 'REDUCE_NEXT_WEEK_VOLUME'
    | 'MAINTAIN_PROGRESSION';

export interface WeeklyCheckinAdaptationAction {
    type: WeeklyCheckinActionType;
    reason: string;
    volumeReductionPercent?: number;
    restDays?: number;
    replaceHighIntensityWithZ2?: boolean;
    promptPhysio?: boolean;
}

export const DEFAULT_WEEKLY_CHECKIN_PREFERENCES: WeeklyCheckinPreferences = {
    enabled: true,
    dayOfWeek: 0,
    time: '19:00',
    pushEnabled: false,
};
